import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://woeexpeqouhtojnuyueg.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndvZWV4cGVxb3VodG9qbnV5dWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDcwNTY0MzcsImV4cCI6MjAyMjYzMjQzN30.nreTdyMMF6nP0oiZkpLN-MP5P0tV4roDMDBeHZ_va2Y"
);

export const getEmployeeService = async (account_uuid) => {
  const { data } = await supabase
    .from("site_employee")
    .select()
    .eq("account_uuid", account_uuid)
    .order("id");
  return await data;
};

export const getEmployeeByUuidService = async (site_uuid) => {
  const { data } = await supabase
    .from("site_employee")
    .select()
    .eq("site_uuid", site_uuid)
    .order("id", { ascending: false });
  return await data;
};

export const setEmployeeService = async (payload) => {
  const { data, error } = await supabase.from("site_employee").insert(payload);
  if (error) {
    return error;
  } else {
    return await data;
  }
};

export const updateEmployeeService = async (payload) => {
  const { data } = await supabase
    .from("site_employee")
    .update(payload)
    .eq("id", payload.id);
  return await data;
};

export const deleteEmployeeService = async (id) => {
  const { data } = await supabase.from("site_employee").delete().eq("id", id);
  const site_uuid = JSON.parse(localStorage.getItem("site"));
  const { data: list, error: ListError } = await supabase.storage
    .from("siamai")
    .list(`docs/${site_uuid}/employee/${id}`);
  const filesToRemove = list.map(
    (x) => `docs/${site_uuid}/employee/${id}/${x.name}`
  );

  const { data: removeData, error: RemoveError } = await supabase.storage
    .from("siamai")
    .remove(filesToRemove);
  return await removeData;
};

export const uploadFileService = async (id, site_uuid, file) => {
  const { data, error } = await supabase.storage
    .from("siamai")
    .upload(`docs/${site_uuid}/employee/${id}/${file.newName}`, file);
  if (error) {
    await deleteFileService(id, site_uuid, file.newName);
    const { data, error } = await supabase.storage
      .from("siamai")
      .upload(`docs/${site_uuid}/employee/${id}/${file.newName}`, file);
    if (error) {
      return error;
    }
    return await `https://woeexpeqouhtojnuyueg.supabase.co/storage/v1/object/public/siamai/docs/${site_uuid}/employee/${id}/${file.newName}`;
  } else {
    return await `https://woeexpeqouhtojnuyueg.supabase.co/storage/v1/object/public/siamai/docs/${site_uuid}/employee/${id}/${file.newName}`;
  }
};

export const deleteFileService = async (id, site_uuid, file) => {
  const { data, error } = await supabase.storage
    .from("siamai")
    .remove([`docs/${site_uuid}/employee/${id}/${file}`]);
  if (error) {
    return error;
  } else {
    return await data;
  }
};
